import { RESET_STATE } from '../../../../reducer';

export const LOAD_DIRECT_MERCHANTS = 'LOAD_DIRECT_MERCHANTS';
export const SET_DIRECT_MERCHANTS = 'SET_DIRECT_MERCHANTS';
export const DIRECT_MERCHANTS_FAILED_LOAD = 'DIRECT_MERCHANTS_FAILED_LOAD';

export const loadDirectMerchants = () => ({
  type: LOAD_DIRECT_MERCHANTS
});

export const setDirectMerchants = directMerchants => ({
  type: SET_DIRECT_MERCHANTS,
  directMerchants
});

export const failedLoad = () => ({
  type: DIRECT_MERCHANTS_FAILED_LOAD
});

const initialState = {
  loading: true,
  failedLoad: false,
  // total_users: 0,
  users: [],
  has_failed_merchant_registrations: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_DIRECT_MERCHANTS:
      return {
        ...state,
        loading: false,
        failedLoad: false,
        ...action.directMerchants
      };
    case DIRECT_MERCHANTS_FAILED_LOAD:
      return {
        ...state,
        loading: false,
        failedLoad: true
      };
    case RESET_STATE:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
